<template>
    <div>
      <div class="row loader-filter-row" v-if="showFilters">
        <div class="col" v-for="ddlLoader in 4" v-bind:key="ddlLoader">
          <div class="da-skeleton-loader loader-text"></div>
          <div class="da-skeleton-loader loader-dropdown"></div>
        </div>
      </div>

      <div class="da-skeleton-loader loader-header-1"></div>
      <hr style="border-color:#EEE; margin-top:21px; margin-bottom:25px;" />
      <div class="da-skeleton-loader loader-text"></div>
      <br />
      <div class="col loader-list">
        <div class="row loader-list-item" v-for="rtItem in 4" v-bind:key="rtItem">
          <div class="da-skeleton-loader loader-avatar"></div>
          <div class="col">
            <div class="da-skeleton-loader loader-header-2"></div>
            <div class="da-skeleton-loader loader-text"></div>
            <div class="da-skeleton-loader loader-text-small"></div>
          </div>
          <div>
            <div class="da-skeleton-loader loader-button"></div>
            <div style="text-align:center">
              <div class="da-skeleton-loader loader-text-small"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from 'vue'
export default defineComponent({
  components: {},
  props:{
    showFilters: Boolean
  }
})
</script>
<style lang="scss" scoped>
.loader-filter-row {
  margin-bottom: 80px;
}
</style>